import dayjs from "dayjs";

export interface IHealthCheckHistoryDate {
  label: string;
  value: string;
}

export const isoToChartFriendly = ({
  date,
  includeYear = false,
}: {
  date: string;
  includeYear?: boolean;
}) => {
  const dateObject = dayjs(date);
  const formatString = includeYear ? "MMM D, YYYY" : "MMM D";

  return dateObject.format(formatString);
};

export const getDashboardDateRanges = () => {
  const today = dayjs();
  const todayFormatted = today.format("YYYY-MM-DD");

  return {
    thisMonth: {
      startDate: today.startOf("month").format("YYYY-MM-DD"),
      endDate: todayFormatted,
    },
    previousMonth: {
      startDate: today
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: today.subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
    },
    previousThreeMonths: {
      startDate: today
        .subtract(3, "month")
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: today.subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
    },
    previousSixMonths: {
      startDate: today
        .subtract(6, "month")
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: today.subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
    },
    previousTwelveMonths: {
      startDate: today
        .subtract(1, "year")
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: today.subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
    },
    last7Days: {
      startDate: today
        .subtract(7, "days")
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: todayFormatted,
    },
    last30Days: {
      startDate: today
        .subtract(30, "days")
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: todayFormatted,
    },
    last90Days: {
      startDate: today
        .subtract(90, "days")
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: todayFormatted,
    },
  };
};

export const getHealthCheckHistoryMonths = () => {
  const startDate = dayjs("2023-08-01");
  let currentDate = dayjs().startOf("month");

  const results: IHealthCheckHistoryDate[] = [];

  while (currentDate.isAfter(startDate)) {
    results.push({
      label: currentDate.clone().format("MMMM YYYY"),
      value: currentDate.clone().format("YYYY-MM-DD"),
    });

    currentDate = currentDate.subtract(1, "month");
  }

  return results;
};
